import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('SegmentResponse')
export class SegmentResponse {

    @JsonProperty('segmentKey', String)
    public segmentKey: string;

}